var React = require('react');
var Modal = require('react-bootstrap').Modal;
var Button = require('react-bootstrap').Button;
var Table = require('react-bootstrap').Table;
var ButtonLink = require('react-router-bootstrap').ButtonLink;
var cx = require('classnames');
var moment = require('moment');

var Config = require('../../config/Config');
var encryptValue = require('../../util/eCrypt');

var Loading = require('../Loading');
var ServiceActions = require('../../actions/ServiceActions');
var ClientServiceStore = require('../../stores/ClientServiceStore');
var UserStore = require('../../stores/UserStore');
var Invocation = require('../../api/Invocation');
var PaymentTokenStore = require('../../stores/PaymentTokenStore');
var Bandwidth = require('../../util/Bandwidth');
var Currency = require('../../util/Currency');
var DateRange = require('../../util/DateRange');
var validateLuhn = require('../../util/Luhn');
var TokenSelector = require('../Payment/TokenSelector')
var CardForm = require('../Payment/CardForm')
var CardValidator = require('../../validators/CardValidator')

function getState(props) {
  const service = ClientServiceStore.getService(props.params.serviceId)

  return {
    service,
    selectedOffer: null,
    tokens: PaymentTokenStore.get() || [],
    tokensLoading: PaymentTokenStore.loading(),
  }
}

var Upgrade = React.createClass({
  contextTypes: {
    router: React.PropTypes.func
  },
  componentDidMount: function() {
    ClientServiceStore.addChangeListener(this.update);
    PaymentTokenStore.addChangeListener(this.update);

    Invocation.clientService
      .upgradeOptions(this.props.params.serviceId)
      .then((response) => this.setState({
        options: response.body.options,
      }))
  },
  componentWillMount: function () {
    this.update()

    var user = UserStore.getUser();

    if (user && !ClientServiceStore.has() && !ClientServiceStore.loading()) {
      ServiceActions.getServices(user);
    }
  },
  componentWillUnmount: function () {
      ClientServiceStore.removeChangeListener(this.update);
      PaymentTokenStore.removeChangeListener(this.update);
  },
  applyCoupon: function () {
    this.setState({
      options: null,
    })

    Invocation.clientService
      .upgradeOptions(this.props.params.serviceId, this.state.coupon)
      .then((response) => this.setState({
        options: response.body.options,
      }))
  },
  submit: function (e) {
    e.preventDefault()

    this.setState({
      error: '',
    })

    if (
      this.state.service.billing_group.token_required &&
      !this.state.token &&
      !this.state.card.number
    ) {
      this.setState({
        error: 'Please select a payment method.',
      })

      return
    }

    if (!this.state.agree) {
      this.setState({
        error: 'To continue, please agree to the Terms and Conditions and Acceptable Use Policy.'
      })

      return
    }

    let card

    if (this.state.token) {
      const violations = CardValidator.validateCvn(this.state.card)
      if (violations.length) {
        this.setState({ violations })

        return
      }
    }

    if (this.state.selectedOffer.proRataAmount > 0 && this.state.token === null) {
      let { expiryMonth, expiryYear, number, cvn, ...other } = this.state.card || {}

      const violations = CardValidator.validateCard(this.state.card)
      if (number && !validateLuhn(number)) {
        violations.push({
          property_path: 'card.number',
          message: 'Invalid card number',
        })
      }

      if (violations.length) {
        this.setState({ violations })

        return;
      }

      card = {
        expiry_month: expiryMonth,
        expiry_year: expiryYear,
        number: number ? encryptValue(number, Config.eCryptKey) : null,
        cvn: cvn ? encryptValue(cvn, Config.eCryptKey) : null,
        ...other
      }
    }

    this.setState({
      working: true,
      violations: [],
    })

    Invocation.clientService.upgrade(
      this.state.service.id,
      this.state.selectedOffer.offer.id,
      card, // card,
      this.state.token ? this.state.token.uuid : null,
      (this.state.token && this.state.card.cvn) ? encryptValue(this.state.card.cvn, Config.eCryptKey) : null, // if we've got a token, add the CVN from card
      this.state.token !== false, // invoice unless token === false
      false,
      this.state.selectedOffer.couponValid ? this.state.coupon : ''
    ).then(
      () => this.setState({ working: false, complete: true }),
      obj => {
        this.setState({
          working: false,
          violations: (obj.res && obj.res.body) ? obj.res.body.violations : [],
        })

        throw obj
      }
    )
      .then(() => {
        ClientServiceStore.clear()
        this.setState(this.getInitialState())

        var user = UserStore.getUser();
        if (user) {
          ServiceActions.getServices(user);
        }
      })
  },
  update: function () {
    const newState = getState(this.props)

    if (newState.service && newState.service.restrictions) {
      for (let i = 0; i < newState.service.restrictions.length; i++) {
        const restrictionType = newState.service.restrictions[i].type;
        if (restrictionType === 'plan_change') {
          this.context.router.transitionTo('service', {serviceId: newState.service.id});
        }
      }
    }

    if (
      newState.service !== this.state.service &&
      newState.service &&
      newState.service.coupon
    ) {
      newState.coupon = newState.service.coupon.code
    }

    this.setState(newState)
  },
  getInitialState: function () {
    return {
      agree: false,
      card: {},
      complete: false,
      coupon: null,
      error: '',
      options: null,
      selectedOffer: null,
      token: null,
      tokenCvn: null,
      violations: [],
      working: false,
    }
  },
  handleOfferSelection: function (offer) {
    this.setState({
      selectedOffer: offer,
    })
  },
  handleTokenSelection: function (token) {
    this.setState({
      token: token,
    })
  },
  isDowngrade: function (offer) {
    // Switching between CGNAT and non-CGNAT plans is a sidegrade and should happen immediately.
    if (offer.attributes.includes('cgnat') !== this.state.service.offer.attributes.includes('cgnat')) {
      return false;
    }
    return offer.monthlyRecurringAmount < this.state.service.accounting.monthlyRecurringAmountWithoutCoupons
  },
  render: function () {
    const underContractUntil = this.state.service && this.state.service.underContractUntil && moment(this.state.service.underContractUntil)
    const underContract = underContractUntil && underContractUntil.isAfter()
    const tokenViolations = this.state.violations.filter(v => v.property_path === 'token')

    const selectedOfferCoupon = this.state.selectedOffer && this.state.selectedOffer.couponValid

    return (
      <div className="row">
        <div className="col-sm-8">
          <div className="modal-header">
              <h4>Upgrade Service</h4>
          </div>

          {this.state.complete && (
            <div>
              <div className="modal-body">
                <div className="alert alert-success">
                  <div className="pull-left" style={{ marginRight: '0.5em' }}>
                    <i className="fa fa-check fa-3x"></i>
                  </div>

                  <p>Your service will be changed to <b>{this.state.selectedOffer.offer.name}</b>.</p>
                </div>
              </div>

              <div className="modal-footer">
                <ButtonLink className="pull-left" to="service" params={{ serviceId: this.props.params.serviceId }}>&larr; Back to Service</ButtonLink>
              </div>
            </div>
          )}

          {!this.state.complete && (
            <form onSubmit={this.submit}>
              <div className="modal-body">
                {!this.state.service && (
                  <Loading />
                )}

                {this.state.service && (
                  <div>
                    {underContract && (
                      <div className="alert alert-warning">
                        <p>This service is under contract until {underContractUntil.format(_DATE_FORMAT)}. You may only upgrade to a larger plan until this date.</p>
                      </div>
                    )}

                    <div className="form-group">
                      <label className="col-md-3 control-label">Old Plan</label>
                      <div className="col-md-9">
                        <p>
                          {this.state.service.service_display_name}
                          {!this.state.service.offer && (
                            <span className="text-muted small"><br />
                            You are on a legacy plan. Upgrading to the equivalent plan may provide additional benefits for the same monthly cost.
                          </span>
                          )}
                        </p>
                      </div>
                    </div>

                    <div className="form-group">
                      <label className="col-md-3 control-label">Coupon</label>
                      <div className="col-md-9">
                        <div className="input-group">
                          <input type="text" className="form-control" placeholder="Enter Coupon Code.." value={this.state.coupon} onChange={e => this.setState({ coupon: e.target.value }) } />
                          <div className="input-group-btn">
                            <Button bsStyle="primary" onClick={this.applyCoupon}>Apply</Button>
                          </div>
                        </div>

                        <div className="help-block">
                          Entering a coupon code will update the prices for any plans
                          where the coupon is valid.
                        </div>
                      </div>
                    </div>

                    <div className="clearfix" />

                    <Table hover striped style={{ marginTop: '1em' }}>
                      <thead>
                      <tr>
                        <th />
                        <th>Plan</th>
                        <th>Detail</th>
                        <th>Adjust</th>
                      </tr>
                      </thead>
                      <tbody>
                      {!this.state.options && (<tr><td colSpan={4}><Loading /></td></tr>)}
                      {this.state.options && !this.state.options.length && (
                        <tr><td colSpan={4}>There are no upgrade options for your service at this time.</td></tr>
                      )}
                      {this.state.options && this.state.options.map(option => {
                        const exact = this.state.service && this.state.service.offer && this.state.service.offer.id === option.offer.id
                        const equiv = this.state.service &&
                          this.state.service.accounting.interval === option.offer.period &&
                          this.state.service.accounting.interval_price === option.offer.recurringAmount &&
                          this.state.service.offer.speed === option.offer.speed;
                        const downgrade = this.isDowngrade(option.offer)
                        const disabled = (underContract && downgrade) ||
                          (this.state.service.offer &&
                            this.state.service.offer.id == option.offer.id)
                        const couponLowerPrice = option.couponValid && option.recurringWithCoupon !== option.offer.recurringAmount

                        return (
                          <tr key={option.offer.id} onClick={disabled ? undefined : () => this.handleOfferSelection(option)} className={disabled ? 'text-muted' : ''}>
                            <td><input type="radio" checked={this.state.selectedOffer && this.state.selectedOffer.offer.id === option.offer.id} disabled={disabled} /></td>
                            <td>
                              <strong>{option.offer.name}</strong>
                              {disabled && !equiv && !exact && (
                                <span className="small text-warning"><br />You cannot downgrade to this plan until {underContractUntil.format(_DATE_FORMAT)}</span>
                              )}
                              {exact && (
                                <span className="text-muted small"><br />You are currently on this plan.</span>
                              )}
                              {equiv && !exact && (
                                <span className="text-muted small"><br />This plan is equivalent to your current plan.</span>
                              )}
                              {option.offer.criticalInformationSummaryDoc &&
                                <div><a className="text-muted small" href={option.offer.criticalInformationSummaryDoc} onClick={e => e.stopPropagation()} target="_blank">Critical Information Summary</a></div>}
                            </td>
                            <td className="small">
                              {!option.offer.bandwidthPacks.length && (
                                <div><em>Unlimited usage</em></div>
                              )}
                              {option.offer.bandwidthPacks.map(pack => (
                                <div>{Bandwidth.format(pack.bytes)} {pack.direction === 'both' ? 'combined' : (pack.direction + 'load')} </div>
                              ))}
                              <div style={{ textDecoration: couponLowerPrice ? 'line-through' : '' }}>
                                {Currency.format(option.offer.recurringAmount)} / {DateRange.simpleFormat(option.offer.period)}
                              </div>
                              {couponLowerPrice && (
                                <div>
                                  {Currency.format(option.recurringWithCoupon || 0)} / {DateRange.simpleFormat(option.offer.period)}
                                </div>
                              )}
                            </td>
                            <td>
                              <div style={{ textDecoration: couponLowerPrice ? 'line-through' : '' }}>
                                {Currency.format(option.proRataAmount)}
                              </div>
                              {couponLowerPrice && (
                                <div>
                                  {Currency.format(option.proRataWithCoupon || 0)}
                                </div>
                              )}
                            </td>
                          </tr>
                        )
                      })}
                      </tbody>
                    </Table>

                    {this.state.selectedOffer && (
                      <div>
                        {this.state.selectedOffer.couponValid === false && (<div className="alert alert-warning">
                          You can not apply your existing coupon to this new plan. Please email <a href="mailto:support@infinite.net.au">support@infinite.net.au</a> referencing your existing coupon code and we will issue you a new coupon. Please note this may not be at same value as your existing coupon.
                        </div>)}
                        <div className="form-group row">
                          <label className="col-md-3 control-label">New Recurring</label>
                          <div className="col-md-9">
                            <p>
                              Your next recurring invoice will be for{' '}
                              <b>{Currency.format(selectedOfferCoupon ? this.state.selectedOffer.recurringWithCoupon : this.state.selectedOffer.offer.recurringAmount)}{' '}
                                / {DateRange.simpleFormat(this.state.selectedOffer.offer.period)}</b>
                            </p>
                          </div>
                        </div>

                        {this.isDowngrade(this.state.selectedOffer.offer) &&
                          <div className="form-group row">
                            <label className="col-md-3 control-label">Downgrade</label>
                            <div className="col-md-9">Your downgrade will be scheduled for the end of the current billing period.</div>
                          </div>}

                        <div className="form-group row">
                          <label className="col-md-3 control-label">Adjustment</label>
                          <div className="col-md-9">
                            <p>
                              <b>{Currency.format(selectedOfferCoupon ? this.state.selectedOffer.proRataWithCoupon : this.state.selectedOffer.proRataAmount)}</b>
                            </p>

                            {(selectedOfferCoupon ? this.state.selectedOffer.proRataWithCoupon : this.state.selectedOffer.proRataAmount) > 0 && (
                              <span className="help-block">
                                You will be immediately charged this adjustment for the remainder of
                                the current period. This is a once off adjustment fee for this period
                                calculated based on days remaining to next invoice date.
                              </span>
                            )}
                          </div>
                        </div>

                        {this.state.service && this.state.service.billing_group.token_required && !this.state.service.billing_group.payment_token && (
                          <div className="form-group">
                            <div className="col-md-9 col-md-offset-3">
                              <p className="text-warning">
                                To perform this upgrade, we require you to set a credit card on your account. This
                                card will be used for monthly recurring payments in addition to any charges for
                                this upgrade.
                              </p>
                            </div>
                          </div>
                        )}

                        {(this.state.selectedOffer.proRataAmount > 0 || this.state.service.billing_group.token_required) && (
                          <div>
                            <div className={cx("form-group", { 'has-error': tokenViolations.length > 0 })}>
                              <label className="col-md-3 control-label">Payment Method</label>
                              <div className="col-md-9">
                                <TokenSelector
                                  allowNone={!this.state.service.billing_group.token_required}
                                  noneLabel="Invoice for later payment"
                                  selected={this.handleTokenSelection}
                                  token={this.state.token}
                                  tokens={this.state.tokens}
                                />

                                {tokenViolations.length > 0 && (
                                  <div style={{ marginBottom: '0.5em' }}>
                                    {tokenViolations.map(v => (
                                      <span key={v} className="help-block">{v.message}</span>
                                    ))}
                                  </div>
                                )}
                              </div>
                            </div>

                            {this.state.token !== false && (
                              <div className="form-horizontal">
                                <CardForm
                                  card={this.state.card}
                                  cvnOnly={!!this.state.token}
                                  ref="newCard"
                                  handleUpdate={card => this.setState({ card })}
                                  horizontal={[3,5]}
                                  showNotice={false}
                                  violations={this.state.violations}
                                />
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    )}

                  </div>
                )}

                <div className="form-group">
                  <div className="col-md-9 col-md-offset-3" style={{ marginBottom: '2em' }}>
                    <div className="checkbox">
                      <label>
                        <input
                          onChange={e => this.setState({ agree: e.target.checked })}
                          type="checkbox"
                          checked={this.state.agree}
                        />

                        I agree to the Infinite Networks{' '}
                        <span className="text-muted">Standard Terms and Conditions</span> and the{' '}
                        <span className="text-muted">Acceptable Use Policy</span>.
                      </label>
                    </div>

                    <span className="help-block">
                    Our <a href="https://www.infinite.net.au/wp-content/uploads/2023/10/INFINITE-NETWORKS-Standard-Terms-and-Conditions.pdf" target="_blank">Standard Terms and Conditions</a>{' '}
                      and <a href="https://www.infinite.net.au/policies-agreements/" target="_blank">Acceptable Use Policy</a>{' '}
                      are available <a href="https://www.infinite.net.au/policies-agreements/" target="_blank">here</a>.
                  </span>
                  </div>
                </div>

                {this.state.error && (
                  <div className="form-group has-error">
                    <div className="col-md-9 col-md-offset-3" style={{ marginBottom: '2em' }}>
                    <span className="help-block">
                      {this.state.error}
                    </span>
                    </div>
                  </div>
                )}
              </div>

              <div className="modal-footer">
                <ButtonLink className="pull-left" to="service" params={{ serviceId: this.props.params.serviceId }}>Cancel</ButtonLink>
                <Button to="access" bsStyle="success" type="submit" disabled={!this.state.selectedOffer}>
                  {this.state.working && (
                    <span><i className="fa fa-spinner fa-spin"></i> </span>
                  )}
                  Upgrade
                </Button>
              </div>
            </form>
          )}
        </div>
      </div>
    );
  }
})
module.exports = Upgrade;



// WEBPACK FOOTER //
// ./app/components/ClientService/Upgrade.js